import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
  LabelList
} from 'recharts';
import { TotalOngoingChargeTypeChartDataNamed } from 'store/modules/Charts/types';
import { TooltipTotalOngoingCharges } from '../Tooltips';
import { emptyColor, dummyData, policyColors, CustomBarLabel } from '../Utils';
import MorningstarCopyright from 'components/MorningstarCopyright/MorningstarCopyright';
import { radiusVertical } from 'utils/charts';

const emptyColors = [emptyColor, emptyColor];
const colors = [policyColors.existing, policyColors.recommended];

const Tick = ({ payload: { value }, ...rest }: any) => (
  <text {...rest} className="bar-chart-tick" dy={12}>
    {value}
  </text>
);

const TotalOngoingCharge = ({
  data,
  isAnimationActive = false,
  hasExistingPolicies = true,
  height = 300
}: {
  data: Array<TotalOngoingChargeTypeChartDataNamed>;
  height?: number;
  isAnimationActive?: boolean;
  hasExistingPolicies?: boolean;
}) => {
  const isDataProvided = data && data.length > 0;
  const dataToRender = isDataProvided ? data : dummyData.totalOngoingCharges;
  const filteredByFlag = hasExistingPolicies
    ? dataToRender
    : dataToRender.filter(
        (totalCharge: TotalOngoingChargeTypeChartDataNamed) =>
          totalCharge.name !== 'Existing'
      );

  const adjustToPercentage = filteredByFlag.map(
    (data: TotalOngoingChargeTypeChartDataNamed) => ({
      ...data,
      percentage_value: data.percentage_value * 100
    })
  );
  const arrayColorsToRender = isDataProvided ? colors : emptyColors;
  return (
    <>
      <ResponsiveContainer width="100%" height={height}>
        <BarChart
          data={adjustToPercentage}
          margin={{ top: 20, right: 10, left: 0, bottom: 15 }}
        >
          <XAxis
            dataKey="name"
            padding={{ left: 30, right: 30 }}
            tick={<Tick />}
          />
          <YAxis unit="%" width={50} />
          {isDataProvided && <Tooltip content={TooltipTotalOngoingCharges} />}

          <Bar
            dataKey="percentage_value"
            unit="%"
            maxBarSize={90}
            isAnimationActive={isAnimationActive}
            label={(props: any) => <CustomBarLabel {...props} isPercent />}
            radius={radiusVertical}
          >
            <LabelList
              dataKey="percentage_value"
              id="asd"
              content={(props: any) => <CustomBarLabel {...props} isPercent />}
            />
            {adjustToPercentage.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={arrayColorsToRender[index]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <MorningstarCopyright />
    </>
  );
};

export default TotalOngoingCharge;
